module.exports = __webpack_public_path__ + "img/News_item_2.c41b9521.jpg";